/**
 * @module TransformKeys
 */

/**
 * Convenience function to convert all keys in the provided object using the keyTransform function.
 *
 * @param {object} obj - Data object to iterate over and transform keys using the specified keyTransform function.
 * @param {Function} keyTransform - Function used to handle transformation of object keys.
 * @param {Array} exceptions - Array of string exceptions to re-convert if found (e.g. [['_i_d', '_id'], ['_u_r_l', '_url']]).
 *
 * @returns {object} A new object with keys converted via the keyTransform function.
 */
function transformKeys(obj, keyTransform, exceptions) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => transformKeys(item, keyTransform, exceptions));
  }

  const newObj = {};
  for (const key in obj) {
    /* istanbul ignore next */
    if (obj.hasOwnProperty(key)) {
      const newKey = keyTransform(key, exceptions);
      newObj[newKey] = transformKeys(obj[key], keyTransform, exceptions);
    }
  }
  return newObj;
}

module.exports = {
  transformKeys,
};
